import React, { useState, useCallback } from "react";
import { createPortal } from "react-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

const PhotoGallery = ({ photos, title, description }) => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const openPhoto = useCallback((photo) => {
    setSelectedPhoto(photo);
  }, []);

  const closePhoto = useCallback(() => {
    setSelectedPhoto(null);
  }, []);

  return (
    <>
      <section className="relative z-10 pt-[110px] pb-[110px]">
        <div className="container">
          <div
            className="wow fadeInUp mx-auto mb-14 max-w-[690px] text-center lg:mb-[70px]"
            data-wow-delay=".2s"
          >
            <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
              {title}
            </h2>
            {description && (
              <p className="text-base text-body">{description}</p>
            )}
          </div>
        </div>

        <div className="container">
          <div className="wow fadeInUp" data-wow-delay=".3s">
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={16}
              slidesPerView={2}
              loop={photos.length >= 8}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              breakpoints={{
                768: { slidesPerView: 3 },
                992: { slidesPerView: 4 },
              }}
              className="gallery-swiper"
            >
              {photos.map((photo, index) => (
                <SwiperSlide key={index}>
                  <button
                    onClick={() => openPhoto(photo)}
                    className="group block w-full overflow-hidden rounded-xl"
                  >
                    <img
                      src={photo.src}
                      alt={photo.alt || ""}
                      className="aspect-square w-full object-cover duration-300 group-hover:scale-105"
                      loading="lazy"
                    />
                  </button>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>

      {selectedPhoto &&
        createPortal(
          <div
            className="fixed inset-0 z-9999 flex items-center justify-center bg-black/70 p-4"
            onClick={closePhoto}
          >
            <div
              className="relative max-h-[80vh] max-w-[900px] w-full"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={closePhoto}
                className="absolute -top-10 right-0 text-white text-2xl font-bold hover:opacity-70"
                aria-label="Cerrar"
              >
                ✕
              </button>
              <img
                src={selectedPhoto.src}
                alt={selectedPhoto.alt || ""}
                className="w-full max-h-[75vh] object-contain rounded-lg"
              />
            </div>
          </div>,
          document.body,
        )}
    </>
  );
};

export default PhotoGallery;
